import React from 'react';
import Tabs from './ShopListTabs';
import EnabledShops from '../containers/EnabledShops';
import DisabledShops from '../containers/DisabledShops';

const ShopList = () => (
  <div>
    <Tabs>
      <div label="Enabled">
        <EnabledShops />
      </div>
      <div label="Disabled">
        <DisabledShops />
      </div>
    </Tabs>
  </div>
  );

export default ShopList;
